var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('comp-nav'),_c('div',{staticClass:"content",class:_vm.$isMobile && 'content-mobile'},[_c('comp-guidance'),_c('comp-room',{ref:"videoims",attrs:{"sdkAppId":Number(_vm.sdkAppId),"sdkSecretKey":_vm.sdkSecretKey,"userId":_vm.userId,"roomId":Number(_vm.roomId),"cameraId":_vm.cameraId,"microphoneId":_vm.microphoneId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }